let scriptPromise = null;

export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => {
        // eslint-disable-next-line no-console
        console.info("[Razorpay] checkout.js loaded");
        resolve(true);
      };
      s.onerror = () => {
        // eslint-disable-next-line no-console
        console.error("[Razorpay] checkout.js FAILED to load");
        scriptPromise = null;
        resolve(false);
      };
      document.body.appendChild(s);
    });
  }
  return scriptPromise;
}

/**
 * Open Razorpay checkout and route back through three callbacks:
 *  - onSuccess({razorpay_payment_id, razorpay_order_id, razorpay_signature})
 *  - onFailure({code, description, source, step, reason, metadata})
 *  - onDismiss()  (user closed the checkout modal)
 * All three are wired via SDK events (payment.success handler + payment.failed).
 */
export async function openRazorpayCheckout({
  keyId, amount, currency = "INR", orderId,
  name, description, prefill = {},
  onSuccess, onFailure, onDismiss,
}) {
  const ok = await loadRazorpayScript();
  if (!ok) throw new Error("Could not load Razorpay checkout. Check your internet.");

  // eslint-disable-next-line no-console
  console.info("[Razorpay] opening checkout", { keyId, orderId, amount, currency, description });

  const rzp = new window.Razorpay({
    key: keyId,
    amount,
    currency,
    order_id: orderId,
    name,
    description,
    prefill,
    theme: { color: "#D90429" },
    handler: (response) => {
      // eslint-disable-next-line no-console
      console.info("[Razorpay] payment.success", response);
      onSuccess?.(response);
    },
    modal: {
      ondismiss: () => {
        // eslint-disable-next-line no-console
        console.warn("[Razorpay] modal dismissed by user");
        onDismiss?.();
      },
    },
  });

  // Razorpay fires 'payment.failed' when UPI/card is declined but the modal
  // stays open until the user closes it. Attach a listener so we can surface
  // the real error to the app.
  rzp.on("payment.failed", (resp) => {
    const err = resp?.error || {};
    // eslint-disable-next-line no-console
    console.error("[Razorpay] payment.failed", err);
    onFailure?.({
      code: err.code || "UNKNOWN",
      description: err.description || "Payment failed",
      source: err.source,
      step: err.step,
      reason: err.reason,
      metadata: err.metadata || {},
    });
  });

  rzp.open();
  return rzp;
}
